import { GET_REMITTANCE_PAYOUT_CYCLE_FAILURE, GET_REMITTANCE_PAYOUT_CYCLE_REQUEST, GET_REMITTANCE_PAYOUT_CYCLE_RESET, GET_REMITTANCE_PAYOUT_CYCLE_SUCCESS, } from "../../actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const getRemittnacePayoutCycleReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_REMITTANCE_PAYOUT_CYCLE_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case GET_REMITTANCE_PAYOUT_CYCLE_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        case GET_REMITTANCE_PAYOUT_CYCLE_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload, data: null });
        case GET_REMITTANCE_PAYOUT_CYCLE_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, data: null, error: null });
        default:
            return state;
    }
};
export default getRemittnacePayoutCycleReducer;
